import React from 'react'

import classes from './EmpProfileInfo.scss'

import EmpProfileInfoItem from './EmpProfileInfoItem/EmpProfileInfoItem'
import { updateFormOptions } from '../../../../../../../helpers/utils'

const empProfileInfo = ({ forms, formInputChanged, dropdownOptions, edit }) => {
  let formElements = Object.entries(forms).map(form => {
    let [formKey, formAttrs] = form

    let formWithOptions = null

    if (formKey === 'emp_type_id') {
      formWithOptions = updateFormOptions(
        dropdownOptions.empTypeOptions,
        { ...formAttrs },
        'value_list_id',
        'value_list_id',
        'value_list_name',
        'Select Emp Type',
        false,
        false
      )
    } else if (formKey === 'company_id') {
      formWithOptions = updateFormOptions(
        dropdownOptions.companyOptions,
        { ...formAttrs },
        'company_id',
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company',
        false,
        false
      )
    } else {
      formWithOptions = { ...formAttrs }
    }

    formWithOptions = {
      ...formWithOptions,
      elementConfig: {
        ...formWithOptions.elementConfig
        // disabled: !edit
      }
    }
    return (
      <EmpProfileInfoItem
        key={formKey}
        formKey={formKey}
        formAttrs={formWithOptions}
        changed={e => formInputChanged(formKey, e)}
        edit={edit}
      />
    )
  })
  return <div className={classes.EmpProfileInfoWrapper}>{formElements}</div>
}

export default empProfileInfo
